import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/* -------------------- ALL TESTIMONIALS -------------------- */
export const AllTestimonialsThunk = createAsyncThunk(
  "testimonials/AllTestimonialsThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/testimonials/list`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch testimonials");
    }
  }
);

/* -------------------- GET SINGLE TESTIMONIAL -------------------- */
export const GetSingleTestimonialsThunk = createAsyncThunk(
  "testimonials/GetSingleTestimonialsThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/testimonials/show?uuid=${uuid}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch testimonial details");
    }
  }
);

/* -------------------- ADD TESTIMONIAL -------------------- */
export const AddTestimonialsThunk = createAsyncThunk(
  "testimonials/AddTestimonialsThunk",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/testimonials/add`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to add testimonial");
    }
  }
);

/* -------------------- UPDATE TESTIMONIAL -------------------- */
export const UpdateTestimonialsThunk = createAsyncThunk(
  "testimonials/UpdateTestimonialsThunk",
  async ({ uuid, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/testimonials/update`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to update testimonial");
    }
  }
);

/* -------------------- DELETE TESTIMONIAL -------------------- */
export const DeleteTestimonialsThunk = createAsyncThunk(
  "testimonials/DeleteTestimonialsThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/testimonials/delete?uuid=${uuid}`);
      return {
        uuid,
        message: response.data?.message || "Deleted successfully",
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to delete testimonial");
    }
  }
);
